<template>
    <transition
        :name="transitionName"
        :mode="transitionMode"
        :enter-active-class="transitionEnterActiveClass"
        @beforeLeave="beforeLeave"
        @enter="enter"
        @afterEnter="afterEnter">
        <slot />
    </transition>
</template>

<script>
export default {
    data() {
        return {
            prevHeight: 0,
            transitionName: 'fade',
            transitionMode: 'out-in',
            transitionEnterActiveClass: 'fade-enter-active'
        };
    },
    methods: {
        beforeLeave(element) {
            this.prevHeight = getComputedStyle(element).height;
        },
        enter(element) {
            const { height } = getComputedStyle(element);

            // eslint-disable-next-line no-param-reassign
            element.style.height = this.prevHeight;

            setTimeout(() => {
                // eslint-disable-next-line no-param-reassign
                element.style.height = height;
            });
        },
        afterEnter(element) {
            // eslint-disable-next-line no-param-reassign
            element.style.height = 'auto';
        }
    }
};
</script>

<style lang="scss">
@import '../scss/Variables.scss';

.fade-enter-active, .fade-leave-active {
    @include transition(all 0.3s ease);
    opacity: 1;
    overflow: hidden;
}

.fade-enter, .fade-leave-active {
    opacity: 0;
}
</style>